// normalize CSS across browsers
import './src/styles/reset.css'
// custom CSS styles
import './src/styles/global.scss'

import * as Swetrix from 'swetrix'

Swetrix.init('jIehaRSk7W3X')
Swetrix.trackViews()
